import { Directive, ElementRef, inject, Input, OnDestroy, DOCUMENT, afterNextRender } from '@angular/core';
import { copyFile } from 'fs';
import { fromEvent, Subscription } from 'rxjs';

@Directive({
    selector: '[appSpot]',
    standalone: true,
})
export class SpotDirective implements OnDestroy {
    private document = inject(DOCUMENT);
    @Input() backgroundColor: string;
    @Input() text: string;
    @Input() icon: string;

    private element: HTMLElement;
    private spotCircle: ElementRef;
    private subscriptions: Subscription[] = [];
    private initialX = 0;
    private initialY = 0;

    constructor(private elementRef: ElementRef) {
        afterNextRender({
            write: () => this.render(),
        });
    }

    private render(): void {
        this.element = this.elementRef.nativeElement as HTMLElement;
        this.element.style.cursor = 'none';
        this.element.style.position = 'relative';
        this.element.style.overflow = 'unset';

        const spot = this.document.createElement('div');
        spot.className = 'spot-circle';
        spot.className += ' scale-up';
        this.element.appendChild(spot);
        this.spotCircle = new ElementRef(this.element.getElementsByClassName('spot-circle')[0]);

        if (this.backgroundColor) {
            this.spotCircle.nativeElement.style.backgroundColor = this.backgroundColor;
        }

        if (this.icon) {
            const iconElement = this.document.createElement('img');
            iconElement.src = this.icon;
            iconElement.className = 'icon';
            iconElement.alt = this.text;
            this.spotCircle.nativeElement.appendChild(iconElement);
        }

        if (this.text) {
            const textElement = this.document.createElement('div');
            textElement.innerHTML = this.text;
            textElement.className = 'text';
            this.spotCircle.nativeElement.appendChild(textElement);
        }

        const e = fromEvent<MouseEvent>(this.element, 'mouseenter').subscribe((event: MouseEvent) => {
            this.initialX = new DOMMatrixReadOnly(window.getComputedStyle(this.elementRef.nativeElement).getPropertyValue('transform')).m41;
            this.initialY = new DOMMatrixReadOnly(window.getComputedStyle(this.elementRef.nativeElement).getPropertyValue('transform')).m42;
            this.spotCircle.nativeElement.style.transform = `scale(1)`;
        });

        const s = fromEvent<MouseEvent>(this.element, 'mousemove').subscribe((event: MouseEvent) => {
            const pageX = event.pageX;
            const pageY = event.pageY;

            const pos = this.element.getBoundingClientRect();
            const posX = pos.left + window.pageXOffset;
            const posY = pos.top + window.pageYOffset;

            const x = pageX - posX - 50 - this.initialX;
            const y = pageY - posY - 50 - this.initialY;
            this.spotCircle.nativeElement.style.left = x + 'px';
            this.spotCircle.nativeElement.style.top = y + 'px';
        });

        const o = fromEvent<MouseEvent>(this.element, 'mouseleave').subscribe((event: MouseEvent) => {
            this.spotCircle.nativeElement.style.transform = `scale(0)`;
        });

        this.subscriptions.push.apply(this.subscriptions, [s, o, e]);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }
}
